<template>
  <dialogModel
    :title="dialogTitle"
    width="1200px"
    :visible.sync="VisibleDeRe"
    :footer="DeRe == 1"
    @handleClose="handleClose"
    @handleOk="handleUnderstand"
  >
    <div class="dialog-content">
      <div class="Content">
        <div class="section-row">
          <div class="section-col">
            <div class="title">企业信息</div>
            <div class="Content-box">
              <div class="title-p">企业名称</div>
              <div class="title-con">{{ row.orderCompanyName }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">统一社会信用代码</div>
              <div class="title-con">{{ row.orderCreditCode }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">法定代表人(负责人)</div>
              <div class="title-con">{{ row.orderLegalPersonName }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">企业类型</div>
              <div class="title-con">{{ companyTypeText }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">纳税类型</div>
              <div class="title-con">{{ taxTypeText }}</div>
            </div>
          </div>

          <div class="section-col">
            <div class="title">员工信息</div>
            <div class="Content-box">
              <div class="title-p">员工姓名</div>
              <div class="title-con">{{ row.empName }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">员工身份证</div>
              <div class="title-con">{{ row.empIdCard }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">年月份</div>
              <div class="title-con">{{ row.wagesMonthName }}</div>
            </div>
            <div class="Content-box">
              <div class="title-p">工资(元)</div>
              <div class="title-con">{{ row.wagesString }}</div>
            </div>
          </div>
        </div>

        <div class="section-bottom">
          <div class="title">订单信息</div>
          <div class="info-grid">
            <div class="Content-box">
              <div class="title-p">订单时间</div>
              <div class="title-con">{{ row.orderTime || "--" }}</div>
            </div>
          </div>
        </div>

        <div
          class="section-bottom refund-block"
          v-if="DeRe == 1 || DeRe == 2"
        >
          <div class="title">退款信息</div>
          <div class="info-grid">
            <div class="Content-box" v-if="DeRe == 1">
              <div class="title-p">退款金额</div>
              <div class="title-con">0元</div>
            </div>
            <div class="Content-box" v-if="DeRe == 2">
              <div class="title-p">退款原因</div>
              <div class="title-con">{{ dataObj.refundReason || "--" }}</div>
            </div>
            <div class="Content-box" v-if="DeRe == 2">
              <div class="title-p">实际退款金额</div>
              <div class="title-con">
                {{
                  dataObj.refundAmount != null ? dataObj.refundAmount : "--"
                }}元
              </div>
            </div>
          </div>
          <div class="Instruction">(实际退款金额需后台审核)</div>
          <div class="Content-box full-row refund-reason" v-if="DeRe == 1">
            <div class="title-p">退款原因</div>
            <div class="title-con refund-input">
              <el-input
                type="textarea"
                class="textarea-lg"
                placeholder="请输入退款原因"
                v-model="textarea"
                :rows="5"
                maxlength="1500"
                show-word-limit
                resize="none"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </dialogModel>
</template>

<script>
export default {
  props: {
    VisibleDeRe: {},
    DeRe: {},
    row: {},
    seller: {},
    dataObj: {},
  },
  data() {
    return {
      textarea: "",
    };
  },
  computed: {
    dialogTitle() {
      return this.DeRe == 0 ? "详情" : "申请退款";
    },
    companyTypeText() {
      const map = ["有限公司", "个体户", "子公司", "分公司", "其他"];
      const t = this.row && this.row.orderCompanyType;
      return map[t] != null ? map[t] : "--";
    },
    taxTypeText() {
      const t = this.row && this.row.orderTaxType;
      if (t == 0) return "小规模纳税人";
      if (t == 1) return "一般纳税人";
      return "--";
    },
  },
  methods: {
    handleClose() {
      this.$emit("handleCloseDeRe");
      this.textarea = "";
    },
    handleUnderstand() {
      this.$emit("handleConfirmDeRe", this.textarea);
      this.textarea = "";
    },
  },
};
</script>

<style scoped lang="less">
@import "../bookkeeping-detail-dialog.less";
</style>
